import $ from "jquery";

let locations1 = [
  {
    lat: '51.09110309009739',
    lng: '16.3916015625',
    content: 'dolnośląskie'
  },
  {
    lat: '53.062345297908806',
    lng: '18.30322265625',
    content: 'kujawsko-pomorskie'
  },
  {
    lat: '52.7165924',
    lng: '15.2503084',
    content: 'Gorzów Wielkopolski'
  }
];

let locations2 = [
  {
    lat: '51.530618370021664',
    lng: '19.3798828125',
    content: 'łódzkie'
  },
  {
    lat: '49.789776141206005',
    lng: '20.19287109375',
    content: 'małopolskie'
  }
];

let regionsArray = [];
// dolnośląskie (2)
regionsArray['02'] = {
  lat: '51.09110309009739',
  lng: '16.3916015625',
  content: 'dolnośląskie'
};
// kujawsko-pomorskie (4)
regionsArray['04'] = {
  lat: '53.062345297908806',
  lng: '18.30322265625',
  content: 'kujawsko-pomorskie'
};
// lubelskie (6)
regionsArray['06'] = {
  lat: '51.13248657417379',
  lng: '22.8515625',
  content: 'lubelskie'
};
// lubuskie (8)
regionsArray['08'] = {
  lat: '52.26277851622219',
  lng: '15.205078125',
  content: 'lubuskie'
};
// łódzkie (10)
regionsArray['10'] = {
  lat: '51.530618370021664',
  lng: '19.3798828125',
  content: 'łódzkie'
};
// małopolskie (12)
regionsArray['12'] = {
  lat: '49.789776141206005',
  lng: '20.19287109375',
  content: 'małopolskie'
};
// mazowieckie (14)
regionsArray['14'] = {
  lat: '52.42386298221437',
  lng: '21.07177734375',
  content: 'mazowieckie'
};
// opolskie (16)
regionsArray['16'] = {
  lat: '50.66130132074996',
  lng: '17.8857421875',
  content: 'opolskie'
};
// podkarpackie (18)
regionsArray['18'] = {
  lat: '49.874813859775024',
  lng: '22.08251953125',
  content: 'podkarpackie'
};
// podlaskie (20)
regionsArray['20'] = {
  lat: '53.207348640401115',
  lng: '22.96142578125',
  content: 'podlaskie'
};
// pomorskie (22)
regionsArray['22'] = {
  lat: '54.08001767385604',
  lng: '17.8857421875',
  content: 'pomorskie'
};
// śląskie (24)
regionsArray['24'] = {
  lat: '50.29776173609122',
  lng: '18.896484375',
  content: 'śląskie'
};
// świętokrzyskie (26)
regionsArray['26'] = {
  lat: '50.74479822194416',
  lng: '20.67626953125',
  content: 'świętokrzyskie'
};
// warmińsko-mazurskie (28)
regionsArray['28'] = {
  lat: '53.84734199258985',
  lng: '20.7421875',
  content: 'warmińsko-mazurskie'
};
// wielkopolskie (30)
regionsArray['30'] = {
  lat: '52.18201609640111',
  lng: '17.16064453125',
  content: 'wielkopolskie'
};
// zachodniopomorskie (36)
regionsArray['32'] = {
  lat: '53.4173898327434',
  lng: '15.380859375',
  content: 'zachodniopomorskie'
};


let mapMarkers = [];
let zoomRWD, isMap = false;

window.addMarkers = function addMarkers(locations) {
  let infowindow = new google.maps.InfoWindow();
  let marker, i;

  $.each(mapMarkers, (k, v) => {
    if (mapMarkers[k] === undefined) return;
    mapMarkers[k].setMap(null);
  });
  mapMarkers.length = 0;

  $.each(locations, (k, v) => {
    if (locations[k] === undefined) return;

    marker = new google.maps.Marker({
      position: new google.maps.LatLng(v.lat, v.lng),
      map: window.map
    });
    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      isMap = true;
      return function() {
        infowindow.setContent('<div class="info-window">' + v.content + '</div>');
        infowindow.open(window.map, marker);
      }
    })(marker, k));
    mapMarkers[k] = marker;
  });

  if (isMap) {
    $('#section-map').show();
  }

}

window.initMap = function initMap() {
  let center_of_poland = new google.maps.LatLng(52.06870191867627, 19.072265625);
  const win = $(window);
  zoomRWD = 7;
  if (win.width() < 480) {
    zoomRWD = 5
  } else if (win.width() < 992) {
    zoomRWD = 6;
  }

  let mapOptions = {
    zoom: zoomRWD,
    center: center_of_poland,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  }
  window.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
  showAllHurt();
}
function showAllHurt() {
  let markersData = [],
      marker = {};

  $.each(appData.hurtList, (k, valueHurt) => {
    if (valueHurt.latitude && valueHurt.longitude) {
      let contentTmp = '<p>' + valueHurt.nazwa + '<br />' + valueHurt.a_adres + ' <br />' +
          valueHurt.a_kod + ' ' + valueHurt.a_miejsc + '</p>';

      if (valueHurt.tel1) {
        contentTmp += '<p>Telefon: ' + valueHurt.tel1 + '</p>';
      }
      if (valueHurt.tel2) {
        contentTmp += '<p>Telefon: ' + valueHurt.tel2 + '</p>';
      }
      if (valueHurt.email) {
        contentTmp += '<p>E-mail: <a href="mailto:' + valueHurt.email + '">' + valueHurt.email + '</a></p>';
      }
      if (valueHurt.www && valueHurt.typ === 'C') {
        contentTmp += '<p><a href="' + valueHurt.www + '" target="_blank" class="marker-link-contact">Strona WWW</a></p>';
      }

      const mapDestination = (valueHurt.nazwa + ', ' + valueHurt.a_adres + ' ' + valueHurt.a_kod + '%2C' + valueHurt.a_miejsc)
        .replaceAll(' ', '+');
      contentTmp += '<a class="map-info-btn" href="https://www.google.com/maps/dir/?api=1&destination=' + mapDestination + '" target="_blank">Wyznacz trasę</a>';

      marker = {
        lat: valueHurt.latitude,
        lng: valueHurt.longitude,
        content: contentTmp
      };
    }
    if (marker.lat && marker.lng) {
      markersData.push(marker);
    }
    marker = {};
  });

  addMarkers(markersData);
}
function moveToLocation(lat, lng){
  const center = new google.maps.LatLng(lat, lng);
  window.map.panTo(center);
  // window.map.setZoom(4);
}

$(document).ready(function() {
  if (googleMapsApiKey) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.google.com/maps/api/js?libraries=geometry&sensor=true&callback=initMap&region=PL&language=pl&key=' + googleMapsApiKey;
    document.body.appendChild(script);
  }

  let tmpZoom;
  $(window).on('resize', function(){
    const win = $(this);
    if (win.width() < 480) {
      tmpZoom = 5
    } else if (win.width() < 992) {
      tmpZoom = 6;
    } else {
      tmpZoom = 7;
    }

    if (window.map !== undefined && zoomRWD !== tmpZoom) {
      window.map.setZoom(tmpZoom);
      zoomRWD = tmpZoom;
    }
  });
});
